<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave"
                @row-update="handleUpdate" @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button type="primary" icon="el-icon-plus" size="small" plain @click.stop="handleAdd()">新增
                    </el-button>
                    <el-button type="warning" icon="el-icon-delete" size="small" plain
                        @click.stop="handleDel('DELETE_OPTION', '逻辑删除')">删除
                    </el-button>
                    <el-button type="danger" icon="el-icon-delete" size="small" plain
                        @click.stop="handleDel('DELETE_OPTION', '物理删除')">物理删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button type="primary" icon="el-icon-edit" size="small" plain
                        @click.stop="handleEdit(scope.row, scope.index)">编辑
                    </el-button>
                </template>
                <template slot-scope="scope" slot="distributorIdForm">
                    <el-select v-model="distributor" placeholder="请选择经销商" required value-key="id" filterable>
                        <el-option v-for="distributor in distributors" :key="distributor.id" :label="distributor.shopName"
                            :value="distributor"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope" slot="provinceForm">
                    <el-input type="input" name="title" :value="point.pname" disabled></el-input>
                </template>
                <template slot-scope="scope" slot="cityForm">
                    <el-input type="input" name="title" :value="point.cityname" disabled></el-input>
                </template>
                <template slot-scope="scope" slot="areaForm">
                    <el-input type="input" name="title" :value="point.adname" disabled></el-input>
                </template>
                <template slot-scope="scope" slot="provincesForm">
                    <avue-map v-model="point"></avue-map>
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { distributionAreaOption } from "@/const/salesCloud/distributionAreaOption";
import {
    findDistributionAreaList,
    addDistributionArea,
    editDistributionArea,
    delDistributionArea
} from "@/api/salesCloud/distributionArea"
import { findShop } from "@/api/salesCloud/productOrderDetailsMerchant"
import { findByLabel } from "@/util/util"
import { DIC } from "@/const/dic"

export default {
    name: "distributionArea",
    components: {},
    data() {
        return {
            tableOption: distributionAreaOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            tabelObj: {},
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
            grade: {
                box: false,
                check: []
            },
            distributor: {},
            distributors: [],
            point: {}

        };
    },
    created() {

        this.handleList();
        findShop().then((res) => {
            let data = JSON.parse(res.data);
            this.distributors = data;

        })
    },
    watch: {},
    mounted() {
    },
    computed: {
        ...mapGetters(["permission"])
    },
    props: [],
    methods: {
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage,
                params.size = pageSize
            findDistributionAreaList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            })
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = page
            params.size = this.page.pageSize
            findDistributionAreaList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            })
        },
        searchChange(params) {
            this.tableLoading = true;
            // let params = this.$refs.crud.searchForm
            params.page = this.page.currentPage
            params.size = this.page.pageSize
            findDistributionAreaList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: params.page,
                    pageSize: params.size
                };
                this.tableLoading = false;
            })
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm
            params.page = page.currentPage
            params.size = page.pageSize
            findDistributionAreaList(params).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            })
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            // this.clean()
            this.$refs.crud.rowAdd();
        },
        handleEdit(row, index) {
            this.distributor = { id: row.distributorId }
            this.point.location = {}
            this.point.location.lng = row.longitude
            this.point.location.lat = row.latitude
            this.point.pname = row.province
            this.point.cityname = row.city
            this.point.adname = row.area
            this.$refs.crud.rowEdit(row, index);
        },
        /**
         * @title 获取数据
         * @detail 赋值为tableData表格即可
         *
         **/
        handleList() {
            this.tableLoading = true;
            let parmas = {
                page: this.page.currentPage,
                size: this.page.pageSize
            }
            findDistributionAreaList(parmas).then((res) => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            })
        },
        /**
         * @title 数据添加
         * @param row 为当前的数据
         * @param done 为表单关闭函数
         *
         **/
        handleSave(row, done) {
            row.distributorId = this.distributor.id
            addDistributionArea(row).then(response => {
                if (response.code == '200') {
                    this.$message({
                        showClose: true,
                        message: "添加成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error"
                    })
                    done();
                    this.$refs.crud.rowAdd();
                    return
                }

            }).catch(error => {
                this.loading = false
                this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                })
            })
            this.distributor = {}
            done();
        },
        clean() {
            // this.openingName = ''
            // this.mobile = ''
            // this.bank = {}
            // this.number = ''
            // this.openingBank = ''
            // this.id=''
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange() {
            // console.log(val);
            // this.tableRow = val;
            // this.$notify({
            //     showClose: true,
            //     message: JSON.stringify(val),
            //     type: 'success',
            // });
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(dicName, label) {
            if (this.$refs.crud.tableSelect.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择要操作的数据",
                    type: "error"
                })
                return
            }

            this.$confirm(`是否确认删除?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    let ids = new Array();
                    for (let row of this.$refs.crud.tableSelect) {
                        ids.push(row.id)
                    }

                    delDistributionArea(findByLabel(DIC.DELETE_OPTION, label), ids).then(response => {
                        if (response.code == '200') {
                            this.$message({
                                showClose: true,
                                message: "删除成功",
                                type: "success"
                            });
                            this.handleList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error"
                            })
                        }

                    }).catch(error => {
                        this.loading = false
                        this.$message({
                            showClose: true,
                            message: error,
                            type: "error"
                        })
                    })
                })
                .catch(() => {
                });

        },
        /**
         * @title 数据更新
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         * @param done 为表单关闭函数
         *
         **/
        handleUpdate(row, index, done) {
            row.longitude = this.point.location.lng
            row.latitude = this.point.location.lat
            row.province = this.point.pname
            row.city = this.point.cityname
            row.area = this.point.adname
            row.distributorId = this.distributor.id
            editDistributionArea(row).then(response => {
                if (response.code == '200') {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success"
                    });
                    this.handleList();
                } else {
                    this.$message({
                        showClose: true,
                        message: response.message,
                        type: "error"
                    })
                    done();
                    this.$refs.crud.rowEdit(obj, index);
                    return
                }

            }).catch(error => {
                this.loading = false
                this.$message({
                    showClose: true,
                    message: error,
                    type: "error"
                })
            })
            done();
        }

    }
};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>
